<template>
  <div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
    <div class="offcanvas__info info-open">
      <div class="offcanvas__wrapper">
        <div class="offcanvas__content">
          <div class="offcanvas__top mb-5 d-flex justify-content-between align-items-center">
            <div class="offcanvas__logo">
              <router-link :to="{name:'home'}">
                <img src="assets/images/logo/white-logo.svg" alt="logo-img">
              </router-link>
            </div>
            <div class="offcanvas__close" type="button" data-bs-dismiss="offcanvas" aria-label="Close">
              <button>
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
          <div class="mobile-menu fix mb-3 mean-container">
            <div class="mean-bar">
              <nav class="mean-nav">
                <ul style="display: none;">
                  <li class="pointer">
                    <a href="/">Home</a>
                  </li>
                  <li class="pointer">
                    <a @click.prevent="navigateAbout"  data-bs-dismiss="offcanvas"
                       aria-label="Close">About Us</a>
                  </li>
                  <li class="pointer">
                    <a  @click.prevent="navigateToHowItWork"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close">How It Work ?
                    </a>
                  </li>
                  <li class="pointer">
                    <a @click.prevent="navigateFeature"  data-bs-dismiss="offcanvas"
                       aria-label="Close">Features</a>
                  </li>
                  <li class="pointer">
                    <a @click.prevent="navigateFaq"  data-bs-dismiss="offcanvas"
                       aria-label="Close">FAQ</a>
                  </li>
                  <li>
                    <router-link :to="{name:'ContactUs'}">Contact Us</router-link>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <header class="header-section-1">
    <div id="header-sticky" class="header-1">
      <div class="container">
        <div class="mega-menu-wrapper">
          <div class="header-main">
            <div class="header-left">
              <div class="logo">
                <router-link :to="{name:'home'}" class="header-logo">
                  <img src="/assets/images/logo/web_logo.svg" class="logo-w" alt="logo-img">
                </router-link>
              </div>
            </div>
            <div class="header-middle">
              <div class="mean__menu-wrapper">
                <div class="main-menu">
                  <nav id="mobile-menu" class="d-none d-xl-block">
                    <ul>
                      <li class="pointer">
                        <router-link :to="{name:'home'}">Home</router-link>
                      </li>
                      <li class="pointer">
                        <a @click.prevent="navigateAbout">About Us</a>
                      </li>
                      <li class="pointer">
                        <a @click.prevent="navigateToHowItWork">How It Work ?</a>
                      </li>
                      <li class="pointer">
                        <a @click.prevent="navigateFeature">Features</a>
                      </li>
                      <li class="pointer">
                        <a @click.prevent="navigateFaq">FAQ</a>
                      </li>
                      <li>
                        <router-link :to="{name:'ContactUs'}">Contact Us</router-link>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
            <div class="header-right d-flex justify-content-end align-items-center">
              <div class="header-button ms-4">
                <a @click.prevent="downloadApk" class="theme-btn">
                  <span>
                    Get Started
                    <i class="fa-solid fa-arrow-right-long"></i>
                  </span>
                </a>
              </div>
              <div class="header__hamburger d-block d-xl-none my-auto" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
                <div class="sidebar__toggle">
                  <i class="fas fa-bars"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
  <div id="mainbody">
    <router-view/>
  </div>
  <footer class="footer-section position-relative">
    <div class="footer-widgets-wrapper style1 fix">
      <div class="shape1"><img src="assets/images/shape/footerShape1_1.png" alt="shape"></div>
      <div class="shape2"><img src="assets/images/shape/footerShape1_2.png" alt="shape"></div>
      <div class="shape3"><img src="assets/images/shape/footerShape1_3.png" alt="shape"></div>
      <div class="container">
        <div class="row">
          <div class="col-xl-4 col-lg-4 col-md-6 wow fadeInUp" data-wow-delay=".2s">
            <div class="single-footer-widget">
              <div class="widget-head">
                <router-link :to="{name:'home'}">
                  <img src="assets/images/logo/logo.svg" alt="logo-img" style="max-width:230px;">
                </router-link>
              </div>
              <div class="footer-content">
                <p>
                  Immerse yourself in the ultimate sports excitement with our fantasy app. Create your dream team, follow live scores, and challenge friends and fans.
                </p>
              </div>
            </div>
          </div>
          <div class="col-xl-2 col-lg-4 col-md-6 ps-lg-5 wow fadeInUp" data-wow-delay=".4s">
            <div class="single-footer-widget">
              <div class="widget-head">
                <h3> Pages </h3>
              </div>
              <ul class="list-area">
                <li class="pointer">
                  <a @click.prevent="navigateAbout">About Us</a>
                </li>
                <li class="pointer">
                  <a  @click.prevent="navigateToHowItWork">How It Work ?
                  </a>
                </li>
                <li class="pointer">
                  <a @click.prevent="navigateFeature">Features</a>
                </li>
                <li class="pointer">
                  <a @click.prevent="navigateFaq">FAQ</a>
                </li>
                <li>
                  <router-link :to="{name:'ContactUs'}">Contact Us</router-link>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-xl-2 col-lg-4 col-md-6 wow fadeInUp" data-wow-delay=".8s">
            <div class="single-footer-widget">
              <div class="widget-head">
                <h3> Company </h3>
              </div>
              <ul class="list-area">
                <li>
                  <router-link :to="{name:'PrivacyPolicy'}"> Privacy Policy</router-link>
                </li>
                <li>
                  <router-link :to="{name:'TermsAndCondition'}">Terms & Conditions</router-link>
                </li>
                <li>
                  <router-link :to="{name:'RefundAndCancellation'}">Refund & Cancellation</router-link>
                </li>
                <li>
                  <router-link :to="{name:'GameRules'}">Game Rules</router-link>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-xl-4 col-lg-4 col-md-6">
            <div class="single-footer-widget">
              <div class="contact-box">
                <div class="subtitle">Address</div>
                <img src="assets/images/hero/cmpny.svg" class="compny" alt="cmpny"> <br>
                <a href="#">H.No.1-123/3/B/6, Sai Baba Colony,Nizampet, Nizampet, Hyderabad, Qutubullapur, Telangana, India, 500090</a>
                <div class="info">
                  <div class="icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
                      <path d="M3.66671 4.16699H18.3334C19.3417 4.16699 20.1667 4.99199 20.1667 6.00033V17.0003C20.1667 18.0087 19.3417 18.8337 18.3334 18.8337H3.66671C2.65837 18.8337 1.83337 18.0087 1.83337 17.0003V6.00033C1.83337 4.99199 2.65837 4.16699 3.66671 4.16699Z"
                            stroke="#5236FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M20.1667 6L11 12.4167L1.83337 6" stroke="#5236FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </div>
                  <div class="link">
                    <a href="mailto:info@crickdraft.com"> info@crickdraft.com</a>
                  </div>
                </div>
                <div class="info">
                  <div class="icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
                      <g clip-path="url(#clip0_2011_91)">
                        <path d="M13.7959 5.08366C14.6912 5.25834 15.514 5.69623 16.1591 6.34127C16.8041 6.9863 17.242 7.80915 17.4167 8.70449L13.7959 5.08366ZM13.7959 1.41699C15.656 1.62364 17.3906 2.45665 18.7149 3.77925C20.0392 5.10185 20.8744 6.83542 21.0834 8.69533L13.7959 1.41699ZM20.1667 16.0103V18.7603C20.1677 19.0156 20.1154 19.2683 20.0132 19.5022C19.9109 19.7361 19.7609 19.9461 19.5728 20.1187C19.3846 20.2913 19.1625 20.4227 18.9207 20.5045C18.6789 20.5863 18.4226 20.6166 18.1684 20.5937C15.3476 20.2872 12.6381 19.3233 10.2575 17.7795C8.0427 16.3721 6.16491 14.4943 4.75752 12.2795C3.20833 9.8881 2.24424 7.1654 1.94335 4.33199C1.92045 4.0785 1.95057 3.82302 2.03181 3.58181C2.11305 3.34061 2.24363 3.11896 2.41522 2.93098C2.58682 2.743 2.79567 2.59281 3.0285 2.48997C3.26132 2.38713 3.513 2.3339 3.76752 2.33366H6.51752C6.96238 2.32928 7.39366 2.48681 7.73097 2.7769C8.06827 3.06698 8.28859 3.46982 8.35085 3.91033C8.46692 4.79039 8.68218 5.65449 8.99252 6.48616C9.11585 6.81426 9.14254 7.17083 9.06943 7.51363C8.99632 7.85643 8.82648 8.17109 8.58002 8.42033L7.41585 9.58449C8.72078 11.8794 10.6209 13.7796 12.9159 15.0845L14.08 13.9203C14.3293 13.6739 14.6439 13.504 14.9867 13.4309C15.3295 13.3578 15.6861 13.3845 16.0142 13.5078C16.8459 13.8182 17.71 14.0334 18.59 14.1495C19.0353 14.2123 19.442 14.4366 19.7327 14.7797C20.0234 15.1228 20.1778 15.5608 20.1667 16.0103Z"
                              stroke="#5236FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      </g>
                      <defs>
                        <clipPath id="clip0_2011_91">
                          <rect width="22" height="22" fill="white" transform="translate(0 0.5)" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <div class="link">
                    <a href="tel:918981576139">+91 8981576139</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bottom style1">
      <div class="container">
        <div class="footer-wrapper d-flex align-items-center justify-content-center">
          <p class="wow fadeInLeft" data-wow-delay=".3s">
            Copyright © 2024 Crickdraft All rights
          </p>
        </div>
      </div>
    </div>
  </footer>

</template>

<script>


export default {
  name: "LayoutView",
  methods: {
    downloadApk() {
      const link = document.createElement('a');
      link.href = 'apk/crickdraft.apk';
      link.setAttribute('download', 'crickdraft.apk');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    navigateToHowItWork() {
      if (this.$route.path !== '/') {
        this.$router.push({ path: '/', hash: '#how_it_work' });
      } else {
        const element = document.querySelector('#how_it_work');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    },
    navigateAbout(){
      if (this.$route.path !== '/') {
        this.$router.push({ path: '/', hash: '#about' });
      } else {
        const element = document.querySelector('#about');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    },
    navigateFeature(){
      if (this.$route.path !== '/') {
        this.$router.push({ path: '/', hash: '#features' });
      } else {
        const element = document.querySelector('#features');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    },
    navigateFaq(){
      if (this.$route.path !== '/') {
        this.$router.push({ path: '/', hash: '#faq' });
      } else {
        const element = document.querySelector('#faq');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    },
  }
}
</script>

<style scoped>
.compny{
  width: 250px;
}
.pointer{
  cursor: pointer;
}
.logo-w{
  width: 230px;
}
@media (max-width: 576px) {
  .logo-w{
    width: 180px;
  }
}
@media (max-width: 991px) {
  .compny{
    width: 220px;
  }
}
</style>